// DomText
import React from 'react';

export default class DomLink extends React.Component {
  render() {
    return (
      <a href={this.props.link ? this.props.link : ''}
        className={this.props.className ? this.props.className : ''}
        target={this.props.target ? this.props.target : ''}
      >
        {this.props.text}
      </a>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/DomLink.jsx